<div id="guidance-dialog" class="dialog-container">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ sectionTitle }}</h4>
    <button id="dialog-close" class="icon-close" (click)="close()"></button>
  </div>
  <div class="container">
    <div class="section-container editor-text" [innerHTML]="guidance"></div>
  </div>
  @if (!guidanceValue && showAcceptance) {
    <div class="container container--sticky-bottom">
      <div class="section-container button-container">
        <sag-ui-button color="secondary" (click)="acceptGuidance(true)">
          {{ "default.buttons.acceptAndClose" | translate }}
        </sag-ui-button>
        <sag-ui-button color="primary" (click)="acceptGuidance()">
          {{ "default.buttons.accept" | translate }}
        </sag-ui-button>
      </div>
    </div>
  }
</div>
